export default "__VITE_ASSET__0rQ6BZk4__"